module.exports = __webpack_public_path__ + "img/logo-menicon-mark.42c65442.svg";